module.exports = __webpack_public_path__ + "img/paypal.043646b6.png";